import cls from 'classnames';
import React from 'react';
import './Card.css';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}
export const Card: React.FC<CardProps> = ({
  children,
  className,
  ...props
}) => (
  <div className={cls(className, 'lb_card')} {...props}>
    {children}
  </div>
);
